// extracted by mini-css-extract-plugin
export default {"errorBoundaryLayoutContainer":"style_errorBoundaryLayoutContainer__HtiEY","content":"style_content__9lTfk","msg":"style_msg__mF5hG","pic":"style_pic__e1enq"};